<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#a)">
      <path
        d="M12 22a9 9 0 1 1 0-18 9 9 0 0 1 0 18Zm0-2a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm1-7h3v2h-5V8h2v5ZM1.747 6.282l3.535-3.535L6.697 4.16 3.16 7.697 1.747 6.282Zm16.97-3.535 3.536 3.535-1.414 1.415-3.536-3.536 1.415-1.414Z"
      />
    </g>
    <defs>
      <clipPath id="a"><path d="M0 0h24v24H0z" /></clipPath>
    </defs>
  </svg>
</template>
